import React from 'react';
import Receipt from '@material-ui/icons/ReceiptOutlined';
import { BodyM } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/payAnyBillStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

const NoBills = () => {
	const classes = useStyles();
	return (
		<div className={classes.noBillsWrapper}>
			<Receipt />
			<BodyM color="disabled-light" disableMargin>
				{translate('bills.no.bills')}
			</BodyM>
		</div>
	);
};

export default NoBills;
